// BB Can Spin — shared 360° can player backed by transparent video. Classic script, no modules.
(function () {
  // Each block instance emits its own <script src> tag; the asset executes once per tag
  if (customElements.get('bb-can-spin')) return;

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  class BBCanSpin extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bbUpgraded) return;
      this.dataset.bbUpgraded = '1';

      this.video = this.querySelector('video');
      this.poster = this.querySelector('[data-bb-poster]');
      if (!this.video) return;

      // WebKit (Safari + every iOS browser) un-premultiplies alpha on decode, so it gets the
      // premultiplied mp4; Blink/Gecko read the stored RGB straight, so they get the webm.
      // GestureEvent is WebKit-only, which is exactly the set routed through AVFoundation.
      var isWebKit = typeof window.GestureEvent !== 'undefined';
      var picked = isWebKit ? this.dataset.srcMp4 : this.dataset.srcWebm;
      if (picked) this.video.src = picked;

      var self = this;
      var seconds = parseFloat(this.dataset.seconds) || 6;
      var encoded = parseFloat(this.dataset.encodedSeconds) || 6;

      // The clip is encoded at one rotation; speed changes are a playback rate, not a re-encode
      this.rate = encoded / seconds;

      var staticOnly = this.hasAttribute('data-static') ||
                       (window.Shopify && Shopify.designMode) ||
                       reducedQuery.matches;

      this.video.addEventListener('loadeddata', function () {
        if (self.poster) self.poster.classList.add('is-hidden');
      });

      // A decode error leaves the poster up rather than an empty box
      this.video.addEventListener('error', function () {
        if (self.poster) self.poster.classList.remove('is-hidden');
      });

      if (staticOnly) {
        // Show one frame, never play — the editor and reduced-motion both want a still can
        this.video.preload = 'metadata';
        this.video.autoplay = false;
        this.video.load();
        return;
      }

      this.video.playbackRate = this.rate;

      // Nothing downloads until the block approaches the viewport
      this.io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) self.start();
          else self.stop();
        }
      }, { rootMargin: this.dataset.rootMargin || '300px 0px' });
      this.io.observe(this);

      this._onVis = function () {
        if (document.hidden) self.stop();
        else if (self.visible) self.start();
      };
      document.addEventListener('visibilitychange', this._onVis);
    }

    disconnectedCallback() {
      this.stop();
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this._onVis);
      this.dataset.bbUpgraded = ''; // a genuine re-insert should re-initialise
    }

    start() {
      this.visible = true;
      if (document.hidden) return;
      if (this.video.preload !== 'auto') this.video.preload = 'auto';
      this.video.playbackRate = this.rate;
      var p = this.video.play();
      // Autoplay can still be refused; the poster stays visible rather than erroring
      if (p && p.catch) p.catch(function () {});
    }

    stop() {
      this.visible = false;
      if (!this.video.paused) this.video.pause();
    }
  }

  customElements.define('bb-can-spin', BBCanSpin);
})();
